import { render, staticRenderFns } from "./PodborTree.vue?vue&type=template&id=264a5a84"
import script from "./PodborTree.vue?vue&type=script&lang=js"
export * from "./PodborTree.vue?vue&type=script&lang=js"
import style0 from "./PodborTree.vue?vue&type=style&index=0&id=264a5a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports